import _ from 'lodash';

export const isNumber = (n: any) => _.isFinite(Number(n));
